module.exports = __webpack_public_path__ + "static/media/user-profile.975effc9.png";